import { staticText } from 'utils/staticText';

export const RewardCardTranslations = staticText({
  flashDeals: {
    _: 'Flash Deals',
  },
  bankDeals: {
    _: 'Bank Offers',
    'zh-hk': '迎新優惠',
  },
  exclusiveOffers: {
    _: ':brand Exclusive Offers',
    // House wording drops the brand name (see TableBuilder module_exclusive).
    'zh-hk': '獨家獎賞',
  },
  fullCardList: {
    _: 'See Full Reward List',
    'zh-hk': '查看完整獎賞清單',
  },
  minimiseRewardList: {
    _: 'Minimise Reward List',
    'zh-hk': '收起獎賞清單',
  },
  worth: {
    _: 'Worth',
    'zh-hk': '價值',
  },
});
